import { $api } from "../generated/client";

type ReturnRequestsTimeChartParams = {
	fromTimestamp: number;
	toTimestamp: number;
	productId?: string;
	variantId?: string;
	resolution?: string;
	reason?: string;
};

export default function useReturnRequestsTimeChart(
	shopId: string,
	params: ReturnRequestsTimeChartParams,
) {
	return $api.useQuery(
		"get",
		"/shops/{shopId}/analytics/return-requests-time-chart",
		{
			params: {
				path: { shopId },
				query: params,
			},
			enabled: !!params.toTimestamp,
		},
	);
}
